import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const data = [
  { name: "Lagos", orders: 93 },
  { name: "Abuja", orders: 50},
  { name: "Rivers", orders: 49 },
  { name: "Ogun", orders: 80 },
  { name: "Oyo", orders: 26 },
  { name: "Osun", orders: 35 },
  { name: "Delta", orders: 15 },
  { name: "Ondo", orders: 15 },
];

const TotalOrdersProcessed = () => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data} barSize={100}>
        <CartesianGrid vertical={false} stroke="#E5E7EB" strokeOpacity={0.7} />
        <XAxis dataKey="name" />
        <YAxis ticks={[0, 25, 50, 75, 100]} tick={{ fontWeight: "700" }} />
        <Tooltip />
        <Bar dataKey="orders" fill="#215CDE" stackId="a" name="Orders" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default TotalOrdersProcessed;
